import { render, staticRenderFns } from "./SideBarNotification.vue?vue&type=template&id=1f45ae54&lang=pug&"
import script from "./SideBarNotification.vue?vue&type=script&lang=ts&"
export * from "./SideBarNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports